import * as XLSX from "xlsx";

function formatDateExcel(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("es-MX", {
    dateStyle: "short",
    timeStyle: "short",
  });
}

/**
 * Exporta a Excel solo pruebas Go/No-Go (ReactionTestResult).
 * @param {Array} records - documentos seleccionados del historial
 */
export function downloadGonogoExcel(records) {
  if (!records?.length) return;

  const resumenRows = records.map((r) => ({
    Paciente: r.patient || "",
    Fecha: formatDateExcel(r.testday),
    Prueba: r.testname || "Prueba Go/No-Go",
    "Total ensayos": r.summary_metrics?.total_trials ?? "",
    "Media tiempo reacción (ms)": r.summary_metrics?.mean_reaction_time_ms ?? "",
    "Errores de omisión": r.summary_metrics?.omission_errors ?? "",
    "Errores por comisión": r.summary_metrics?.commission_errors ?? "",
    "Respuestas correctas": r.summary_metrics?.correct_hits ?? "",
  }));

  const detalleRows = [];
  records.forEach((r) => {
    (r.trials || []).forEach((t) => {
      detalleRows.push({
        Paciente: r.patient || "",
        Fecha: formatDateExcel(r.testday),
        Ensayo: t.trial_number ?? "",
        Color: t.stimulus_color === "green" ? "Verde" : "Rojo",
        Acción: t.action_taken === "pressed" ? "Espacio" : "Sin acción",
        Correcto: t.is_correct ? "Sí" : "No",
        "Tiempo reacción (ms)": t.reaction_time_ms ?? "",
      });
    });
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    wb,
    XLSX.utils.json_to_sheet(resumenRows),
    "Resumen"
  );
  XLSX.utils.book_append_sheet(
    wb,
    XLSX.utils.json_to_sheet(
      detalleRows.length
        ? detalleRows
        : [{ Nota: "Sin detalle de ensayos en las pruebas seleccionadas" }]
    ),
    "Detalle ensayos"
  );

  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `gonogo_${records.length}_pruebas_${date}.xlsx`);
}
